export default {
  TipoTransformador: {
    label: 'fields.asset.transformer.type',
  },
  QuantidadeEnrolamentoMonitorados: {
    label: 'fields.asset.transformer.number-of-monitored-windings',
  },
  TensaoTransformadorInferior: {
    label: 'fields.asset.transformer.lower-voltage',
  },
  TensaoTransformadorSuperior: {
    label: 'fields.asset.transformer.higher-voltage',
  },
  TensaoTransformadorTerciaria: {
    label: 'fields.asset.transformer.tertiary-voltage',
  },
  CorrenteNominalTransformadorInferior: {
    label: 'fields.asset.transformer.nominal-chain-lower',
  },
  CorrenteNominalTransformadorSuperior: {
    label: 'fields.asset.transformer.nominal-chain-higher',
  },
  CorrenteNominalTransformadorTerciaria: {
    label: 'fields.asset.transformer.nominal-chain-tertiary',
  },
  PerdasEmVazio: {
    label: 'asset-information.asset-info.losses.fields.losses-in-empty',
    precision: 3,
  },
  PerdasEmCurtoCircuitoEnrolamento1: {
    label: 'asset-information.asset-info.losses.fields.winding-1',
    precision: 3,
  },
  PerdasEmCurtoCircuitoEnrolamento2: {
    label: 'asset-information.asset-info.losses.fields.winding-2',
    precision: 3,
  },
  PerdasEmCurtoCircuitoEnrolamento3: {
    label: 'asset-information.asset-info.losses.fields.winding-3',
    precision: 3,
  },
  PotenciaAplicadaTestePhx: {
    label: 'asset-information.asset-info.losses.modal.applied-potency-phx-test',
    precision: 3,
  },
  PotenciaAplicadaTestePhy: {
    label: 'asset-information.asset-info.losses.modal.applied-potency-phy-test',
    precision: 3,
  },
  PotenciaAplicadaTestePxy: {
    label: 'asset-information.asset-info.losses.modal.applied-potency-pxy-test',
    precision: 3,
  },
  PerdasCobreTestePhx: {
    label: 'asset-information.asset-info.losses.modal.copper-losses-phx-test',
    precision: 3,
  },
  PerdasCobreTestePhy: {
    label: 'asset-information.asset-info.losses.modal.copper-losses-phy-test',
    precision: 3,
  },
  PerdasCobreTestePxy: {
    label: 'asset-information.asset-info.losses.modal.copper-losses-pxy-test',
    precision: 3,
  },
};
